import { render, staticRenderFns } from "./customer-and-vendor-invoice-statistic.vue?vue&type=template&id=72016434&scoped=true&"
import script from "./customer-and-vendor-invoice-statistic.vue?vue&type=script&lang=js&"
export * from "./customer-and-vendor-invoice-statistic.vue?vue&type=script&lang=js&"
import style0 from "./customer-and-vendor-invoice-statistic.vue?vue&type=style&index=0&id=72016434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72016434",
  null
  
)

export default component.exports